module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/img-dinner-course-20e9f0c9a36182df3368ab37a8981b58.png";